import { Injectable } from '@angular/core';
import { User } from '../../shared/user/model/user.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { SkipErrorInterceptor } from '../../blocks/interceptor/error.interceptor';
import { map } from 'rxjs/operators';

@Injectable()
export class MailService {
    private baseUrl = '/bmsapi/auth'; // sendResetEmail/{username}

    constructor(private http: HttpClient) {
    }

    send(user: User): Observable<any> {

        const httpContext = new HttpContext().set(SkipErrorInterceptor, true);
        return this.http
            .post<any>(`${this.baseUrl}/sendResetEmail/${user.userUUID}`,
                { observe: 'response', context: httpContext })
            .pipe(map((res: HttpResponse<any>) => res.body));
    }
}
